import { ListResponse, PostModel } from "common/models/baseModel";
import api from "utils/api";
import { endpoints } from "utils/endpoints";

import { createQueryKeys } from "@lukemorales/query-key-factory";
import { testimonialView } from "../types/testimonialView";
import {
  ITestimonial,
  ITestimonialGridFilter,
  ITestimonialGridModel,
} from "./types";
import {
  IDropdownModel,
  IValueLabelDropDownModel,
} from "common/models/IDropdownModel";

export const testimonial = createQueryKeys("testimonial", {
  list: (postModel: PostModel<ITestimonialGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<ListResponse<ITestimonialGridModel>>(
        endpoints.testimonial.list,
        postModel
      ),
  }),
  get: (id: number) => ({
    queryKey: [id],
    queryFn: () => api.get<ITestimonial>(`${endpoints.testimonial.get}/${id}`),
  }),
  view: (id: number) => ({
    queryKey: [id],
    queryFn: () =>
      api.get<testimonialView>(`${endpoints.testimonial.view}/${id}`),
  }),
  batchValues: {
    queryKey: null,
    queryFn: () =>
      api.get<IDropdownModel[]>(`${endpoints.testimonial.batchValues}`),
  },
  memberLabelValues: (inputValue: string, id: string) => ({
    queryKey: [inputValue, id],
    queryFn: () =>
      api.post<IValueLabelDropDownModel[]>(
        `${endpoints.testimonial.memberLabelValues}`,
        {
          name: inputValue,
          id: id,
        }
      ),
  }),
});
